/* Copyright (c) 2016-2024 Planticle Pty Ltd */
"use strict";

var program = {
	code: "abc",
	name: "Aussie Bird Count",
	description: "",
	canParticipate: () => false,
	canFilterBy: (user) => true,
	fields: function() { return {}; },
	programData: function() { return {}; },
	visibleSharedSiteLayers: () => [],
	defaultAreaLayer: (layers) => null,
	filterAreaLayers: (layer) => false,
	hideWaterLevel: true,
	hideSurveyType: true,
	surveyTypeOptions: [],
	canAssignSurveyOwner: false,
	afterSelect: function(survey) {
		survey.type({
			code: 'incidental_search',
			name: 'Incidental search'
		});
		survey.assignOwner(false);
	},
	beforeDeselect: function(survey) {
		survey.type(null);
	},
	allSpeciesRecordedEnabled: () => false,
	multipleDaysEnabled: () => false,
	observerCountEnabled: () => false,
	observerCountIsOptional: () => true,
	hideProgramTab: true
};

export default program;
